import { put, select, takeEvery } from 'redux-saga/effects';
import { safeSaga } from 'store';
import {
    SET_CLINICAL_STUDY_CATEGORIZATION,
    UPDATE_CLINICAL_STUDY_CATEGORIZATION,
    RESET_CLINICAL_STUDY_CATEGORIZATION,
} from 'store/key';
import { produce } from 'utility/general';

const defaultResultList = {
    /** key is array of row's index */
    0: {
        Y: {
            next: 1 /** value is array of row's index */,
            result: null,
        },
        N: {
            next: null,
            result: 'B',
        },
    },
    1: {
        Y: {
            next: 2,
            result: null,
        },
        N: {
            next: 7,
            result: null,
        },
    },
    2: {
        Y: {
            next: 3,
            result: null,
        },
        N: {
            next: 4,
            result: null,
        },
    },
    3: {
        Y: {
            next: 7,
            result: null,
        },
        N: {
            next: 4,
            result: null,
        },
    },
    4: {
        Y: {
            next: null,
            result: 'C',
        },
        N: {
            next: 5,
            result: null,
        },
    },
    5: {
        Y: {
            next: null,
            result: 'C',
        },
        N: {
            next: 6,
            result: null,
        },
    },
    6: {
        Y: {
            next: null,
            result: 'C',
        },
        N: {
            next: null,
            result: 'A',
        },
    },
    7: {
        Y: {
            next: null,
            result: 'A',
        },
        N: {
            next: 8,
            result: null,
        },
    },
    8: {
        Y: {
            next: 9,
            result: null,
        },
        N: {
            next: 10,
            result: null,
        },
    },
    9: {
        Y: {
            next: 10,
            result: null,
        },
        N: {
            next: null,
            result: 'A',
        },
    },
    10: {
        Y: {
            next: null,
            result: 'A',
        },
        N: {
            next: 11,
            result: null,
        },
    },
    11: {
        Y: {
            next: null,
            result: 'A',
        },
        N: {
            next: null,
            result: 'B',
        },
    },
};

const defaultRows = [
    {
        id: '1',
        riskGroup: 'Human Subjects',
        number: '1',
        riskFactors: 'Recruitment of human subjects',
        action: null,
        disabled: false,
    },
    {
        id: '2',
        riskGroup: 'Medical Products',
        number: '2',
        riskFactors: 'Use of any medical product that is not needed or used for the Subjects’ normal clinical care',
        action: null,
        disabled: true,
    },
    {
        id: '3',
        riskGroup: 'Medical Products',
        number: '3',
        riskFactors: 'Each medical product used is registered or permitted to be marketed in Hong Kong',
        action: null,
        disabled: true,
    },
    {
        id: '4',
        riskGroup: 'Medical Products',
        number: '4',
        riskFactors: 'Use of each medical product is within the labeled use in Hong Kong',
        action: null,
        disabled: true,
    },
    {
        id: '5',
        riskGroup: 'Medical Products',
        number: '5',
        riskFactors:
            'Any medical product used is a chemical or biological drug that is to be tested in humans for the first time',
        action: null,
        disabled: true,
    },
    {
        id: '6',
        riskGroup: 'Study Designs',
        number: '6',
        riskFactors:
            'The study is a phase 1 clinical trial on a chemical or biological drug as designated on its study protocol',
        action: null,
        disabled: true,
    },
    {
        id: '7',
        riskGroup: 'Study Designs',
        number: '7',
        riskFactors:
            'The study only has human pharmacology, toxicity and/or safety (but not efficacy) of the chemical or biological drug as its primary objective(s) as specified on its study protocol',
        action: null,
        disabled: true,
    },
    {
        id: '8',
        riskGroup: 'Study Designs',
        number: '8',
        riskFactors:
            'Involvement of placebo, impeding access to available treatment, or withdrawal of ongoing treatment driven by the study protocol',
        action: null,
        disabled: true,
    },
    {
        id: '9',
        riskGroup: 'Clinical Procedures',
        number: '9',
        riskFactors:
            'Involvement of any clinical procedure that is not needed or applied for the subjects’ normal clinical care',
        action: null,
        disabled: true,
    },
    {
        id: '10',
        riskGroup: 'Clinical Procedures',
        number: '10',
        riskFactors: 'Each clinical procedure applied presents no more than minimal clinical risk to the subjects',
        action: null,
        disabled: true,
    },
    {
        id: '11',
        riskGroup: 'Subject Assignment Methods',
        number: '11',
        riskFactors:
            'Subjects are assigned to different clinical intervention by randomization or other research specific methods (other than by the professional judgment of qualified medical professionals)',
        action: null,
        disabled: true,
    },
    {
        id: '12',
        riskGroup: 'Subject Vulnerability',
        number: '12',
        riskFactors: 'Involvement of vulnerable subjects',
        action: null,
        disabled: true,
    },
];

const getInitialState = () => ({
    defaultRows: defaultRows,
    rows: defaultRows,
    channel: null,
    mapResultList: defaultResultList,
    defaultResultList: defaultResultList,
    formCompleted: false,
});

function* updateState(action) {
    const { clinicalStudyCategorization } = yield select();
    if (action.payload === undefined) return;

    for (let key in action.payload) {
        clinicalStudyCategorization[key] = action.payload[key];
    };
    
    yield put({
        type: SET_CLINICAL_STUDY_CATEGORIZATION,
        payload: clinicalStudyCategorization,
    });
}

const reducer = (state = getInitialState(), action) => {
    switch (action.type) {
        case RESET_CLINICAL_STUDY_CATEGORIZATION:
            return getInitialState();
        case SET_CLINICAL_STUDY_CATEGORIZATION:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        default:
            return state;
    }
};

export function* watchClinicalStudyCategorization() {
    yield takeEvery(UPDATE_CLINICAL_STUDY_CATEGORIZATION, safeSaga(updateState));
}

export default reducer;
